var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ChineseLibClassify"},[_c('div',{staticClass:"title"},[_vm._v("中图分类")]),_c('div',{staticClass:"type-list-view"},_vm._l((_vm.records),function(item,index){return _c('div',{key:index,staticClass:"list-item"},[_vm._v(" "+_vm._s(item.type)+" ("+_vm._s(item.count)+") ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }